import { useOrganization } from '../../features/organization/OrganizationContext';
import { BetaBadge } from '../../shared/ui/BetaBadge';
import { GrowLogo, GrowMark } from '../../shared/ui/GrowLogo';

/**
 * The top of the sidebar: the Kudos space. There used to be an organisation
 * switcher here; Kudos is now one space (ADR-025), so it is a label.
 */
export default function OrgSwitcher() {
  const { activeOrgId, organizations } = useOrganization();
  const space = organizations.find((o) => o.organizationId === activeOrgId);
  const name = space?.organizationName ?? 'Grow';
  return (
    <div className="org-switcher">
      <div className="org-switcher__trigger org-switcher__trigger--static">
        {name === 'Grow' ? (
          <GrowLogo tone="light" height={24} className="org-switcher__logo" />
        ) : (
          <>
            <GrowMark tile size={26} className="org-switcher__org-mark" />
            <span className="org-switcher__trigger-name">{name}</span>
          </>
        )}
        <BetaBadge />
      </div>
    </div>
  );
}
